//
//
//
//
//
//
//
//
//
//
//
//

import AsyncValidator from 'async-validator'
export default {
  name: 'VuxFormField',
  inject: ['form'],
  props: {
    prop: String,
    rules: [Object, Array],
    required: Boolean,
    message: String
  },
  computed: {
    isRequired () {
      const { rules, required } = this
      if (rules && rules.length) {
        const rulesRequired = rules.every((rule) => rule.required)
        return rulesRequired || required
      }
      return required
    },
    modelValue () {
      return this.form.model[this.prop]
    }
  },
  watch: {
    fieldValue (val) {
      this.validate()
      this.$emit('on-change', val)
      this.form.model[this.prop] = val
    },
    modelValue (val) {
      this.fieldValue = val
    }
  },
  data () {
    return {
      fieldValue: this.form.model[this.prop],
      validateState: '',
      validateMessage: this.message,
      initialValue: ''
    }
  },
  mounted () {
    const { fieldValue } = this
    if (Array.isArray(fieldValue)) {
      this.initialValue = [].concat(fieldValue)
    } else {
      this.initialValue = fieldValue
    }
  },
  methods: {
    getRules () {
      const selfRules = this.rules || []
      const requiredRule =
        this.isRequired !== undefined ? { required: !!this.isRequired } : []
      if (this.message && this.isRequired) {
        requiredRule.message = this.message
      }
      return selfRules.some((rules) => rules.required)
        ? [].concat(selfRules)
        : [].concat(selfRules, requiredRule)
    },
    validate (cb) {
      const rules = this.getRules()
      const descriptor = {}
      descriptor[this.prop] = rules
      const validator = new AsyncValidator(descriptor)
      const model = {}
      model[this.prop] = this.fieldValue
      validator.validate(
        model,
        { firstFields: true },
        (errors, invalidFields) => {
          this.validateState = errors ? 'error' : 'success'
          this.validteMessage = errors ? errors[0].message : ''
          cb(this.validteMessage, invalidFields)
        }
      )
    },
    clearValidate () {
      this.validateState = ''
      this.validateMessage = ''
    },
    resetField () {
      const { initialValue } = this
      if (Array.isArray(initialValue)) {
        this.fieldValue = [].concat(initialValue)
      } else {
        this.fieldValue = initialValue
      }
      this.$nextTick(() => {
        this.clearValidate()
      })
    }
  },
  created () {
    this.form.addField(this)
  },
  beforeDestroy () {
    this.form.removeField(this)
  }
}
